var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HealthCheckup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13.222,
    viewBox: "0 0 14 13.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#055ca7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.909,2.914a2.2,2.2,0,1,0,2.227,2.2,2.213,2.213,0,0,0-2.227-2.2Zm-8.845,1.6a.8.8,0,0,0-.675.374A1.847,1.847,0,0,0,2.2,5.814a1.81,1.81,0,0,0,.127,1.9l2.847,4.017a.059.059,0,0,0,0,.007v.314a4.136,4.136,0,0,0,8.272,0v-1.1a.778.778,0,0,0,.318-.625.8.8,0,0,0-1.591,0,.779.779,0,0,0,.318.625v1.1a3.182,3.182,0,0,1-6.363,0v-.314c0-.005,0-.01,0-.015L8.8,7.662a1.791,1.791,0,0,0,.075-1.876,1.829,1.829,0,0,0-.914-.82.791.791,0,1,0-.23.946.9.9,0,0,1,.305.323A.871.871,0,0,1,8,7.148l-2.364,3.59L3.113,7.173a.869.869,0,0,1-.062-.924.882.882,0,0,1,.446-.4.79.79,0,1,0,.567-1.336ZM10.6,7.941A1.182,1.182,0,0,0,9.409,9.115v3.431a3.591,3.591,0,0,0,.563,1.931,2.522,2.522,0,0,0,1.886-2.425V11.21a1.386,1.386,0,0,1-.318-.886,1.432,1.432,0,0,1,2.863,0,1.386,1.386,0,0,1-.318.886v.842a4.7,4.7,0,0,1-2.128,3.92,3.3,3.3,0,0,0,.7.129c.079.006.158.008.235.008a2.851,2.851,0,0,0,1.972-.757,3.819,3.819,0,0,0,1.13-2.829V9.064a1.109,1.109,0,0,0-1.107-1.1Z",
    transform: "translate(-1.994 -2.914)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HealthCheckup);
export default __webpack_public_path__ + "static/media/icons8-health-checkup.db07414c7a25762e6d9a26fd6455233e.svg";
export { ForwardRef as ReactComponent };